import createIcon from '../../createIcon';

/**
 * @component @name Splitscreen
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggNFY5SDZWNEgxOFpNMTggMkg2QzQuOSAyIDQgMi45IDQgNFY5QzQgMTAuMSA0LjkgMTEgNiAxMUgxOEMxOS4xIDExIDIwIDEwLjEgMjAgOVY0QzIwIDIuOSAxOS4xIDIgMTggMlpNMTggMTVWMjBINlYxNUgxOFpNMTggMTNINkM0LjkgMTMgNCAxMy45IDQgMTVWMjBDNCAyMS4xIDQuOSAyMiA2IDIySDE4QzE5LjEgMjIgMjAgMjEuMSAyMCAyMFYxNUMyMCAxMy45IDE5LjEgMTMgMTggMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Splitscreen = createIcon('Splitscreen', [
  [
    'path',
    {
      d: 'M18 4V9H6V4H18ZM18 2H6C4.9 2 4 2.9 4 4V9C4 10.1 4.9 11 6 11H18C19.1 11 20 10.1 20 9V4C20 2.9 19.1 2 18 2ZM18 15V20H6V15H18ZM18 13H6C4.9 13 4 13.9 4 15V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V15C20 13.9 19.1 13 18 13Z',
      key: 'faltvj',
    },
  ],
]);

export default Splitscreen;
